
import PropTypes from 'prop-types'
import Paper from '@mui/material/Paper'
import Checkbox from '@mui/material/Checkbox'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

const ServiceTile = ({ checked, onChange, imageSrc, centerImageSrc }) => {
  // Wrap click handler to allow clicking image or logo as well
  const handleImageClick = (e) => {
    e.stopPropagation()
    onChange(e, { checked: !checked })
  }

  return (
    <Stack
      direction="row"
      spacing={1.5}
      alignItems="center"
      sx={{ cursor: 'pointer' }}>
      {/* Keep the toggle button */}
      <Checkbox checked={checked} onChange={onChange} />

      {/* Clickable image area */}
      <Paper
        variant="outlined"
        onClick={handleImageClick}
        sx={{
          overflow: 'hidden',
          width: 180,
          height: 64,
          borderColor: checked ? 'primary.main' : 'divider',
          position: 'relative',
          cursor: 'pointer',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            boxShadow: '0 0 6px rgba(0,0,0,0.15)',
            transform: 'scale(1.02)',
          },
        }}>
        {/* Background image */}
        <Box
          component="img"
          src={imageSrc}
          alt=""
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}/>

        {/* Center logo */}
        {centerImageSrc && (
          <Box
            component="img"
            src={centerImageSrc}
            alt="center"
            onClick={handleImageClick}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '60%',
              maxHeight: '60%',
              objectFit: 'contain',
              cursor: 'pointer',
            }}/>
        )}
      </Paper>
    </Stack>
  )
}

ServiceTile.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  imageSrc: PropTypes.string.isRequired,
  centerImageSrc: PropTypes.string,
}

export default ServiceTile
